import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { useGetComponentTypeByIdMultilingual } from '@wajeez-web/components/helpers';

import { ComponentTypeFormBuilder } from './ComponentTypeFormBuilder';

interface ComponentTypeEditFormProps {
  onSubmit: (componentTypeId: number) => void;
  onCancel: () => void;
}

export const ComponentTypeEditForm = ({
  onSubmit,
  onCancel,
}: ComponentTypeEditFormProps) => {
  const componentTypeByIdMultilingual = useGetComponentTypeByIdMultilingual();

  return (
    <div>
      <h1 className="text-[24px] font-bold">
        <ReturnTranslatedText
          text={`pageHeader.${'Edit Type'}`}
          origintext="Edit Type"
        />
      </h1>
      <div className="mt-6">
        {componentTypeByIdMultilingual.data && (
          <ComponentTypeFormBuilder
            type="Edit"
            onSubmit={onSubmit}
            onCancel={onCancel}
            data={componentTypeByIdMultilingual.data}
          />
        )}
      </div>
    </div>
  );
};
